module.exports = __webpack_public_path__ + "img/1506823267.138ab98c.jpg";